module.exports = __webpack_public_path__ + "media/images/help-close-b8b7569ffca41cf99e87fa15c91e793e.png";